import hottyGrillEntlastung from "./hotty-grill-entlastung.webp";
import hottyGrillfleischRabatt from "./hotty-grillfleisch-rabatt.webp";
import hottySteakRabatt from "./hotty-steak-35-prozent.webp";
import leguanoJaraOutdoor from "./leguano-jara-outdoor.webp";
import leguanoJaraReview from "./leguano-jara-review.webp";
import leguanoJaraVorteile from "./leguano-jara-vorteile.webp";

export type PublishedStaticAd = {
  src: string;
  brand: "Hotty BBQ" | "leguano";
  altKey: string;
  /**
   * Der Blickwinkel, den dieses Motiv fährt — EINE Beschriftung pro Anzeige, die
   * überall gilt. Vorher trugen Hero-Animation und Ergebnis-Raster zwei
   * verschiedene Label-Sätze für dieselben sechs Dateien (dasselbe Motiv war
   * oben „Produktbeweis" und weiter unten „Angebot + Produkt").
   * Die Angaben folgen dem, was im Bild tatsächlich zu sehen ist.
   */
  angleKey: string;
};

/**
 * Ausschließlich Static Ads, die im Publish Hub als `published` geführt werden
 * und eine Meta-Ad-ID besitzen. Die überprüfbaren IDs liegen im gleichnamigen
 * Casework-Manifest unter scripts/.
 */
export const PUBLISHED_STATIC_ADS: PublishedStaticAd[] = [
  {
    src: hottyGrillfleischRabatt,
    brand: "Hotty BBQ",
    altKey: "home.published_ads.hotty_grillfleisch.alt",
    angleKey: "home.published_ads.hotty_grillfleisch.angle",
  },
  {
    src: leguanoJaraVorteile,
    brand: "leguano",
    altKey: "home.published_ads.leguano_vorteile.alt",
    angleKey: "home.published_ads.leguano_vorteile.angle",
  },
  {
    src: hottySteakRabatt,
    brand: "Hotty BBQ",
    altKey: "home.published_ads.hotty_steak.alt",
    angleKey: "home.published_ads.hotty_steak.angle",
  },
  {
    src: leguanoJaraReview,
    brand: "leguano",
    altKey: "home.published_ads.leguano_review.alt",
    angleKey: "home.published_ads.leguano_review.angle",
  },
  {
    src: hottyGrillEntlastung,
    brand: "Hotty BBQ",
    altKey: "home.published_ads.hotty_entlastung.alt",
    angleKey: "home.published_ads.hotty_entlastung.angle",
  },
  {
    src: leguanoJaraOutdoor,
    brand: "leguano",
    altKey: "home.published_ads.leguano_outdoor.alt",
    angleKey: "home.published_ads.leguano_outdoor.angle",
  },
];
